export default "__VITE_ASSET__9nRVP2Q6__"